import { CreditCardIcon, LandmarkIcon, PlusIcon } from "lucide-react";

import { Button } from "@/components/button";
import { cn } from "@/utils/cn";

import { CardBrandMark } from "../../CardBrandMark";
import { usePaymentMethods } from "../../payment-methods/hooks/usePaymentMethods";

const MAX_VISIBLE_PAYMENT_METHODS = 2;

export function PaymentMethodsCard({
  onNavigate,
  projectId,
}: {
  onNavigate: () => void;
  projectId: number;
}) {
  const { data } = usePaymentMethods(projectId);
  const paymentMethods = data
    ? [data.defaultMethod, ...data.backupMethods]
    : [];
  const canAddPaymentMethod =
    !!data && paymentMethods.length < MAX_VISIBLE_PAYMENT_METHODS;

  return (
    <div className="min-w-0 inline-flex flex-col justify-between gap-xs rounded-xl border border-border-secondary bg-bg-primary py-xl px-3xl">
      <div className="flex items-start justify-between">
        <h3 className="text-xl font-semibold text-text-primary">
          Payment methods
        </h3>
        <div className="h-10 w-10 rounded-md bg-bg-brand-secondary flex items-center justify-center">
          <CreditCardIcon className="text-text-brand-primary" size={20} />
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-x-lg gap-y-xs">
        {paymentMethods
          .slice(0, MAX_VISIBLE_PAYMENT_METHODS)
          .map((paymentMethod, index) => (
            <span
              className={cn(
                "flex min-w-0 items-center gap-md rounded-md p-lg",
                index === 0 && "bg-bg-secondary",
              )}
              key={paymentMethod.id}
            >
              {paymentMethod.type === "card" ? (
                <CardBrandMark brand={paymentMethod.brand} />
              ) : (
                <LandmarkIcon
                  aria-hidden="true"
                  className="shrink-0 text-text-primary"
                  size={24}
                />
              )}
              <span className="text-sm font-medium text-text-primary">
                •••• {paymentMethod.last4}
              </span>
            </span>
          ))}

        {canAddPaymentMethod && (
          <Button
            className="px-xs"
            color="color"
            onPress={onNavigate}
            size="lg"
            variant="tertiary"
          >
            <PlusIcon />
            Add new method
          </Button>
        )}
      </div>
    </div>
  );
}
